import React from "react";

const Header = () => {
  return (
    <header>
      <div className="header-logo">Edie</div>
      <div>
        <span className="material-icons">menu</span>
      </div>
    </header>
  );
};

export default Header;
